import React from 'react'
import Item from './item/Item'
import styles from "./productList.module.css"

export function ProductList({ products }) {

    return (
        <div className={styles.productContainer}>
            <ul className={styles.productList}>

                {products ? products.map((product) => {
                    return <Item key={product.id} product={product} />
                }) : null}



            </ul>
        </div>
    )
}
